import React from "react";
import PropTypes from "prop-types";
import { UsersIcon } from "../../../../assets/Icons/UsersIcon";
import "./CalendarEvent.styles.scss";

function CalendarEvent({ event: { confirmed_status, isAdditionalProvider } }) {
  return (
    <div className="appointmentConfirmIconWrapper">
      {confirmed_status === "Confirmed" && (
        <span className="confirmedIcon">
          <i className="fa fa-check-circle" />
        </span>
      )}
      {isAdditionalProvider && (
        <div className="usersIcon">
          <UsersIcon />
        </div>
      )}
    </div>
  );
}

CalendarEvent.propTypes = {
  confirmed_status: PropTypes.string,
};

CalendarEvent.defaultProps = {
  confirmed_status: "Not Confirmed",
};

export default CalendarEvent;
